
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    FEATURE_TAB_UPDATE_UNIT_REQUEST,
    FEATURE_TAB_GET_DEVICE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { featureTabUpdateUnitResult, featureTabGetDeviceResult } from 'Redux/actions';


function* unitDevice({ payload }) {
    try {
        const QUERY = `
            mutation updateUnit ($id: Int!, $label: String, $timezoneId: Int, $unitConfig: UnitConfigInput, $features: UnitFeatureInput!, $installed: Boolean, $installedOn: AWSDateTime, $liveMode:enumLiveMode, $tagIds: [Int] ) {
                result: updateUnit (id: $id, label: $label, timezoneId: $timezoneId, unitConfig: $unitConfig, features: $features, installed: $installed, installedOn: $installedOn, liveMode:$liveMode, tagIds: $tagIds) {
                    id
                    label
                    deviceCategory
                    promiles
                    promilesOdometerCalculated
                    apu
                    hybrid
                    vbus
                    jbus
                    battery
                    useEcuOdometer
                    useEcuEngineHours
                    useEcuSpeed
                    useEcuVin
                    driverBehavior
                    show
                    analytics
                    linkedMode
                    liveMode
                    timezoneId
                    installed
                    installedOn
                    carb
                    deviceModel {
                        id
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                        product
                        geofence
                        input
                        output
                        ota
                        sms
                        starter
                        driverBehavior
                        battery
                        analytic
                        promiles
                        comData
                        pressurePro
                        vbus
                        jbus
                        obd2Alerts
                        motion
                        tow
                        ttu
                        hoursEnable
                        odometerEnable
                        carbEnable
                    }
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(featureTabUpdateUnitResult(data?.result))
        } else {
            yield put(featureTabUpdateUnitResult({ error: true }))
        }

    } catch (exc) {
        yield put(featureTabUpdateUnitResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/featureTab/.components/updateFeature/redux/saga",
            "unitDevice",
        )
    }
}

function* getDevice({ payload }) {
    try {
        let QUERY = `
            query getUnit ($id: Int!) {
                result: getUnit (id: $id) {
                    id
                    companyId
                    company {
                        id
                        dealerId
                    }
                    label
                    esn
                    imei
                    reference
                    deviceCategory
                    promiles
                    promilesOdometerCalculated
                    comdata
                    apu
                    hybrid
                    vbus
                    jbus
                    pressurePro
                    battery
                    useEcuOdometer
                    useEcuEngineHours
                    useEcuSpeed
                    useEcuVin
                    driverBehavior
                    show
                    linkedMode
                    liveMode
                    analytics
                    timezoneId
                    cariq
                    carb
                    installed
                    installedOn
                    linkedByUnit {
                        id
                        label
                        deviceModelId
                    }
                    deviceModel {
                        id
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                        product
                        geofence
                        input
                        output
                        ota
                        sms
                        starter
                        driverBehavior
                        battery
                        analytic
                        promiles
                        comData
                        pressurePro
                        vbus
                        jbus
                        obd2Alerts
                        motion
                        tow
                        ttu
                        hoursEnable
                        odometerEnable
                        cariq
                        carbEnable
                    }
                    tags
                    unitConfig {
                        billingAccountId
                        billingAccount {
                            id
                            name
                        }
                    }
                }
            }
            `;


        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        //timezones ids
        
        let QUERY_TIMEZONE = `
            query getTimezonesSupported {
                result: getTimezonesSupported
            }
        `

        let dataTimezone = yield call(
            clientQuery,
            QUERY_TIMEZONE,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        let timezones = [];
        if (dataTimezone.result) {
            try {
                let resultTimezones = JSON.parse(dataTimezone.result)
                if (resultTimezones.length > 0) {
                    resultTimezones.map((tz, index) => {
                        timezones.push({ id: tz, label: tz });
                    })
                }
            } catch (error) { }
        }

        if (data?.result) {
            data = JSON.parse(JSON.stringify(data))
            data.result.timezones = timezones
            yield put(featureTabGetDeviceResult(data?.result))
        }

    } catch (exc) {
        yield put(featureTabGetDeviceResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/featureTab/.components/updateFeature/redux/saga",
            "getDevice",
        )
    }
}

function* watchMethods() {
    yield takeEvery(FEATURE_TAB_UPDATE_UNIT_REQUEST, unitDevice);
    yield takeEvery(FEATURE_TAB_GET_DEVICE_REQUEST, getDevice);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}